<wd-input-container [name]="name" [classes]="classes()" [label]="label" [helpText]="helpText()" [comments]="comments" [hideComments]="hideComments">
	<input
		[name]="'input' + name"
		type="date"
		class="form-control"
		[ngClass]="classes()"
		[(ngModel)]="datum"
		#inputValue="ngModel"
		(mousedown)="onMouseDown($event)"
		(focus)="onFocus($event)"
		(focusout)="onFocusOut()"
		(change)="onDateChange()"
		(ngModelChange)="onChange()"
		[readonly]="disabled()"
		[attr.tabindex]="disabled() ? -1 : 0"
		(click)="onClick($event)"
	/>
</wd-input-container>
